module.exports = __webpack_public_path__ + "static/media/workPvcCeilings17.b90bb8c1.jpg";